import { Injectable } from '@angular/core';
import { Actions, Effect } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';
import { CommService, CommReceiptsIndexParams, EmailPreviewParams, NumberOfRecipientsParams, SendCommParams, FetchCommSendsParams } from "@services/comm";
import { CommSend } from "@models/comm-send";
import { CommReceipt } from "@models/comm-receipt";
import { Template } from "@models/template";
import { Recipient } from "@models/recipient";
import {
  FETCH_TEMPLATES,
  POPULATE_TEMPLATES,
  FETCH_TEMPLATES_FAILURE,
  RELOAD_EMAIL_TEMPLATES_FAILURE,
  RELOAD_EMAIL_TEMPLATES_SUCCESS,
  RELOAD_EMAIL_TEMPLATES,
  FETCH_EMAIL_PREVIEW,
  POPULATE_EMAIL_PREVIEW,
  FETCH_EMAIL_PREVIEW_FAILURE,
  GET_NUMBER_OF_RECIPIENTS_FAILURE,
  POPULATE_NUMBER_OF_RECIPIENTS,
  GET_NUMBER_OF_RECIPIENTS,
  SEND_COMM,
  SENT_COMM,
  SEND_COMM_FAILURE,
  FETCH_COMM_SENDS,
  POPULATE_COMM_SENDS,
  FETCH_COMM_SENDS_FAILURE,
  FETCH_COMM_RECEIPTS,
  POPULATE_COMM_RECEIPTS,
  FETCH_COMM_RECEIPTS_FAILURE
} from "../comms";

@Injectable()
export class CommEffects {

  constructor(
    private actions: Actions,
    private commService: CommService,
  ) {}

  @Effect() index = this.actions
    .ofType(FETCH_TEMPLATES)
    .map((action: Action) => action.payload)
    .switchMap(() => this.commService.templatesIndex()
      .map((payload: Template[]) => ({ type: POPULATE_TEMPLATES, payload }))
      .catch(() => Observable.of({ type: FETCH_TEMPLATES_FAILURE }))
    )

  @Effect() commSendsIndex = this.actions
    .ofType(FETCH_COMM_SENDS)
    .map((action: Action) => action.payload)
    .switchMap((payload: FetchCommSendsParams) => this.commService.commSendsIndex(payload)
      .map((payload: CommSend[]) => ({ type: POPULATE_COMM_SENDS, payload }))
      .catch(() => Observable.of({ type: FETCH_COMM_SENDS_FAILURE }))
    )

  @Effect() commReceiptsIndex = this.actions
    .ofType(FETCH_COMM_RECEIPTS)
    .map((action: Action) => action.payload)
    .switchMap((params: CommReceiptsIndexParams) => this.commService.commReceiptsIndex(params)
      .map((payload: CommReceipt[]) => ({ type: POPULATE_COMM_RECEIPTS, payload }))
      .catch(() => Observable.of({ type: FETCH_COMM_RECEIPTS_FAILURE }))
    )

  @Effect() emailPreview = this.actions
    .ofType(FETCH_EMAIL_PREVIEW)
    .map((action: Action) => action.payload)
    .switchMap((params: EmailPreviewParams) => this.commService.emailPreview(params)
      .map((payload: string) => ({ type: POPULATE_EMAIL_PREVIEW, payload }))
      .catch(() => Observable.of({ type: FETCH_EMAIL_PREVIEW_FAILURE }))
    )

  @Effect() numberOfRecipients = this.actions
    .ofType(GET_NUMBER_OF_RECIPIENTS)
    .map((action: Action) => action.payload)
    .switchMap((params: NumberOfRecipientsParams) => this.commService.numberOfRecipients(params)
      .map((payload: number) => ({ type: POPULATE_NUMBER_OF_RECIPIENTS, payload }))
      .catch(() => Observable.of({ type: GET_NUMBER_OF_RECIPIENTS_FAILURE }))
    )

  @Effect() reloadEmailTemplates = this.actions
    .ofType(RELOAD_EMAIL_TEMPLATES)
    .switchMap(() => this.commService.reloadEmailTemplates()
      .map(() => ({ type: RELOAD_EMAIL_TEMPLATES_SUCCESS }))
      .catch(() => Observable.of({ type: RELOAD_EMAIL_TEMPLATES_FAILURE }))
    )
  
  @Effect() sendComm = this.actions
    .ofType(SEND_COMM)
    .map((action: Action) => action.payload)
    .switchMap((params: SendCommParams) => this.commService.sendComm(params)
      .map(() => ({ type: SENT_COMM }))
      .catch(() => Observable.of({ type: SEND_COMM_FAILURE }))
    )

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/reducers/effects/comm.ts